<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="true"
    hide-details
  >
    <template v-slot:activator="{ on }">
      <div class="swatch-activator" v-on="on">
        <span class="label-text">{{ labelText }}</span>
        <div :style="swatchStyle" />
      </div>
    </template>

    <v-card outlined class="reusable-color-picker-card">
      <v-card-text>
        <!-- Search by name -->
        <!-- <v-select
          v-if="showSearch"
          v-model="internalColorValue"
          :items="namedColors"
          item-text="name"
          item-value="hex"
          label="Search color"
          dense
          clearable
          hide-details
          :disabled="disabled"
          @change="updateColor"
          ref="colorSelect"
        >
          <template v-slot:item="{ item }">
            <v-list-item @click="selectColor(item)">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <div
                  :style="{
                    width: '30px',
                    height: '30px',
                    borderRadius: '4px',
                    backgroundColor: item.hex,
                    border: '1px solid #000',
                  }"
                />
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-select> -->
        <v-row align="center">
          <!-- ℹ️ Selected color info -->
          <!-- <v-col v-if="showLabel">
            <div class="selected-color-info">
              <template v-if="internalColorValue">
                <div
                  class="color-preview mt-4"
                  :style="{
                    backgroundColor: displayHexColor,
                    border: '1px solid black',
                  }"
                />
              </template>
              <template v-else>
                <p class="mt-2">{{ $t("mission.no_color_selected") }}</p>
              </template>
            </div>
          </v-col> -->
          <v-list dense>
            <template v-for="(item, index) in namedColors">
            <v-list-item :key="index" @click="selectColor(item)">
                <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <div
                    :style="{
                        width: '30px',
                        height: '30px',
                        borderRadius: '4px',
                        backgroundColor: item.hex,
                        border: '1px solid #000',
                    }"
                    />
                </v-list-item-action>
            </v-list-item>
            </template>
          </v-list>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "ReusableColorPicker",
  props: {
    /**
     * Currently selected color (hex or object as emitted by v‑color‑picker).
     */
    value: {
      type: [String, Object],
      default: "#1976D2",
    },

    /**
     * Pre‑named swatches.  Each item: { name: string, hex: string }.
     */
    // namedColors: {
    //   type: Array,
    //   default: () => [
    //     // { name: "Red",           hex: "#F44336" },
    //     // { name: "Pink",          hex: "#E91E63" },
    //     // { name: "Purple",        hex: "#9C27B0" },
    //     // { name: "Deep Purple",   hex: "#673AB7" },
    //     // { name: "Indigo",        hex: "#3F51B5" },
    //     // { name: "Blue",          hex: "#2196F3" },
    //     // { name: "Light Blue",    hex: "#03A9F4" },
    //     // { name: "Cyan",          hex: "#00BCD4" },
    //     // { name: "Teal",          hex: "#009688" },
    //     // { name: "Green",         hex: "#4CAF50" },
    //     // { name: "Light Green",   hex: "#8BC34A" },
    //     // { name: "Lime",          hex: "#CDDC39" },
    //     // { name: "Yellow",        hex: "#FFEB3B" },
    //     // { name: "Amber",         hex: "#FFC107" },
    //     // { name: "Orange",        hex: "#FF9800" },
    //     // { name: "Deep Orange",   hex: "#FF5722" },
    //   ],
    // },

    /** UI toggles & misc props (mostly unchanged) */
    showSwatches: { type: Boolean, default: true },
    showLabel: { type: Boolean, default: true },
    labelText: { type: String, default: "Color" },
    showDetails: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },

    disabled: { type: Boolean, default: false },

    /* Lock picker to swatches only by default */
    hideCanvas: { type: Boolean, default: true },
    hideInputs: { type: Boolean, default: true },
    hideSliders: { type: Boolean, default: true },

    mode: { type: String, default: "rgba" },
    width: { type: [String, Number], default: 300 },
  },

  data() {
    return {
      menu: false,
      pickerMode: this.mode,
      namedColors: [],
    };
  },
  async mounted() {
    await this.getCodes("vehicle_body_color", "vehicle_body_colors").then(
      (data) => {
        this.namedColors = data.map((element) => {
          return {
            name: element.key ? this.$t('vehicle_body_colors.' + element.key)  : element.key,
            hex: element.value,
          };
        });
      }
    );
  },

  computed: {
    /** Hex array that Vuetify's <v-color-picker> expects */
    swatchesHex() {
      return this.namedColors.map((c) => c.hex);
    },

    /** Box style for activator swatch */
    swatchStyle() {
      return {
        backgroundColor: this.displayHexColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "4px",
        border: "1px solid black",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    /** Two‑way binding proxy for v‑color‑picker / v‑autocomplete */
    internalColorValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.updateColor(val);
      },
    },

    /** Parsed color object (extends your previous logic) */
    colorObject() {
      if (typeof this.value === "string") {
        return this.parseHexString(this.value);
      }
      // Fallback when value is already an object (v‑color‑picker returns this)
      return this.value || this.parseHexString("#FFFFFF");
    },

    displayHexColor() {
      return this.colorObject.hex || "#FFFFFF";
    },
    displayRgbaColor() {
      const { r, g, b, a } = this.colorObject.rgba;
      return `rgba(${r}, ${g}, ${b}, ${parseFloat(a.toFixed(2))})`;
    },
    displayHslaColor() {
      const { h, s, l, a } = this.colorObject.hsla;
      return `hsla(${Math.round(h)}, ${Math.round(s * 100)}%, ${Math.round(
        l * 100
      )}%, ${parseFloat(a.toFixed(2))})`;
    },

    /** Display name for currently selected hex, if any */
    colorName() {
      const found = this.namedColors.find(
        (c) => c.hex.toLowerCase() === this.displayHexColor.toLowerCase()
      );
      return found && found.name ? found.name : "";
    },
  },

  watch: {
    mode(newVal) {
      this.pickerMode = newVal;
    },
    pickerMode(val) {
      this.$emit("update:mode", val);
    },
  },

  methods: {
    selectColor(item) {
      this.internalColorValue = item.hex;
      this.updateColor(item.hex);
      this.$refs.colorSelect.blur(); // Close the menu
    },
    /** Primary emit handler */
    updateColor(newColor) {
      const hex = this.convertToHex(newColor);
      this.$emit("input", hex);
      this.$emit("change", hex);
    },

    /** Convert v‑color‑picker result ↦ hex */
    convertToHex(color) {
      if (typeof color === "string" && color.startsWith("#")) return color;
      if (typeof color === "object" && color) {
        if (color.r !== undefined) {
          const r = Math.round(color.r).toString(16).padStart(2, "0");
          const g = Math.round(color.g).toString(16).padStart(2, "0");
          const b = Math.round(color.b).toString(16).padStart(2, "0");
          const a =
            color.a !== undefined
              ? Math.round(color.a * 255)
                  .toString(16)
                  .padStart(2, "0")
              : "ff";
          return `#${r}${g}${b}${a.length === 2 ? a : ""}`.toUpperCase();
        }
        if (color.hex) return color.hex;
      }
      return "#000000";
    },

    /** Parse simple hex string → full color object */
    parseHexString(hex) {
      const to255 = (h) => parseInt(h, 16);
      let r = 0,
        g = 0,
        b = 0,
        a = 1;
      if (hex.length === 4) {
        // #RGB
        r = to255(hex[1] + hex[1]);
        g = to255(hex[2] + hex[2]);
        b = to255(hex[3] + hex[3]);
      } else if (hex.length === 7 || hex.length === 9) {
        // #RRGGBB(A)
        r = to255(hex.substr(1, 2));
        g = to255(hex.substr(3, 2));
        b = to255(hex.substr(5, 2));
        if (hex.length === 9) a = to255(hex.substr(7, 2)) / 255;
      }
      return {
        hex: hex.toUpperCase(),
        rgba: { r, g, b, a },
        hsla: this.hexToHsla(hex),
      };
    },

    textColorForBg(bg) {
      if (!bg || !bg.startsWith("#")) return "black";
      const r = parseInt(bg.substr(1, 2), 16) / 255;
      const g = parseInt(bg.substr(3, 2), 16) / 255;
      const b = parseInt(bg.substr(5, 2), 16) / 255;
      const c = [r, g, b].map((col) =>
        col <= 0.03928 ? col / 12.92 : Math.pow((col + 0.055) / 1.055, 2.4)
      );
      const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
      return L > 0.179 ? "black" : "white";
    },

    /** Convert hex → HSLA */
    hexToHsla(hex) {
      let r = 0,
        g = 0,
        b = 0,
        a = 1;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7 || hex.length === 9) {
        r = parseInt(hex.substr(1, 2), 16);
        g = parseInt(hex.substr(3, 2), 16);
        b = parseInt(hex.substr(5, 2), 16);
        if (hex.length === 9) a = parseInt(hex.substr(7, 2), 16) / 255;
      }
      r /= 255;
      g /= 255;
      b /= 255;
      const max = Math.max(r, g, b),
        min = Math.min(r, g, b);
      let h,
        s,
        l = (max + min) / 2;
      if (max === min) {
        h = s = 0;
      } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }
      return { h: h * 360, s, l, a };
    },
  },
};
</script>

<style scoped>
.swatch-activator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.label-text {
  font-size: 0.7em;
  margin-bottom: 2px;
}
.reusable-color-picker-card {
}
.selected-color-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.selected-color-info h4 {
  margin-bottom: 8px;
}
.color-chip {
  font-weight: bold;
}
.color-preview {
  width: 100%;
  height: 60px;
  border-radius: 4px;
  margin-bottom: 8px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.color-details p {
  margin-bottom: 2px;
  font-size: 0.875rem;
  word-break: break-all;
}
</style>
